var $9022dcf5dfa5b508$exports = {};
$9022dcf5dfa5b508$exports = {
    "Empty": `Tu\u{161}\u{10D}ias`
};


export {$9022dcf5dfa5b508$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
